// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"4656fbaf","45":"73a9f35c","59":"927a0296","198":"c7d2a341","359":"4cd112f5","404":"47b38462","498":"eced3e4b","648":"bed68b6e","787":"578b7b85"}[chunkId] + ".chunk.js";
};